import {Link} from '@primer/react'

import {isAhpDebugLogEnabled} from '../ahp/ahp-debug-log'
import {useActivationTraceUrl} from '../hooks/use-activation-trace-url'

export function TaskStartupTraceLink({diagnosticId}: {diagnosticId: string | undefined}) {
  const traceUrl = useActivationTraceUrl(diagnosticId)
  if (!traceUrl || !isAhpDebugLogEnabled()) return null

  return (
    <>
      {' '}
      <Link inline href={traceUrl} target="_blank" rel="noopener noreferrer">
        View trace in Datadog
      </Link>
    </>
  )
}
